import { Pipe, PipeTransform } from '@angular/core';
import { Options } from 'linkifyjs/lib/linkify';
import linkifyStr from 'linkifyjs/lib/linkify-string';

const defaultOptions: Partial<Options> = {
  target: '_system',
};

@Pipe({
  name: 'linkify',
  standalone: true,
})
export class LinkifyPipe implements PipeTransform {
  public transform(value: string, options?: Partial<Options>): string {
    return value ? linkifyStr(value, Object.assign({}, defaultOptions, options)) : '';
  }
}
